import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import { DynamicMain } from 'components/dynamicForm/main';
import { AppCrashedFallback } from 'components/FatalError/AppCrashFallback';
import { TabIdProps } from 'shared/props';
export function DynamicQuotesTab({ tabId }: TabIdProps) {
  return (
    <div className="flex-grow-1 w-100 min-h-0 bg-lvl3">
      <GenericErrorBoundary Fallback={AppCrashedFallback} key={tabId} context={{ tabId }}>
        <DynamicMain formId={tabId} />
      </GenericErrorBoundary>
    </div>
  );
}

DynamicQuotesTab.displayName = 'DynamicQuotesTab';
